import React from 'react'

import { Props } from './types'

const YouTube: React.FC<Props> = ({ youtubeId }): React.ReactElement => (
  <div
    className='video'
    style={{
      position: 'relative',
      paddingBottom: '56.25%' /* 16:9 */,
      paddingTop: 25,
      height: 0,
    }}
  >
    <iframe
      title='Insurance LoungeYoutube Video'
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
      src={`https://www.youtube.com/embed/${youtubeId}`}
      frameBorder='0'
    />
  </div>
)

export default YouTube
